// @flow
import React from 'react';
// import InfoMessage from './../InfoMessage/InfoMessage';
import './TextArea.scss';

type Props = {
    className?: string,
    placeholder?: string,
    onChange: Function,
    value?: string,
    title?: any,
    required?: boolean,
    name?: string,
    props?: Object,
    feedbackMessage?: string,
    isInvalid?: boolean,
    infoMessage?: any,
    onFocus?: Function,
    isCustomPlaceHolder?: boolean,
    customPlaceHolder?: any,
    onFocusOut?:Function,
    metadata?: Object
}


export default function TextArea({
    className = '', placeholder,  onChange,
    value,  title, isRequired, name = '',metadata, ...props
}: Props): React$Element<any> {

    const textareaType = metadata?.textarea_type;

    const onTextAreaChange = (event) => {
        const userInput = event.target.value;
        
        // Remove HTML tags using regular expression
        const sanitizedInput = userInput.replace(/<\/?[^>]+(>|$)/g, "");
    
        // Handling space issue while user input
        let inputValue;
        
        if(sanitizedInput === ' '){
            inputValue = '';
        } else {
            inputValue = sanitizedInput?.replace('  ',' ');
        }
    
        onChange(inputValue);
    };
    
    return (
        <div id={name} className={``}>
            {title && <label>{title}</label>}
            {/* TODO: Remove if not needed after testing { infoMessage && !value && <InfoMessage text={infoMessage}/>} */}
            <textarea
                {...props}
                className={`${className} ${textareaType || ''}`}
                // autoFocus={autoFocus}
                name={name}
                value={value}
                required={isRequired}
                placeholder={placeholder}
                onChange={onTextAreaChange}/>
            {/* TODO: Remove if not needed after testing {value && !isInvalid && <FontAwesomeIcon className='check-icon' icon={faCheckCircle}/> }
            {feedbackMessage && (
                <div className={isInvalid ? 'invalid-feedback mt-2' : 'valid-feedback mt-2'}>
                    {feedbackMessage}
                </div>
            )} */}
        </div>
    );
}